/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {FaceRetouchingNaturalOutlined, Google, MoneyOutlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Contrato = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor del contrato'} dato={'valor'} {...props}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 12, lineHeight: 1.1}}>El valor mínimo de contrato es de $30 usd y el
                        máximo de 100.000 usd</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={FaceRetouchingNaturalOutlined} nombre={'Nombre de Usuario'}
                                  dato={'nombre'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo de cuenta'} dato={'correo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2} nombre={'Hash único de cuenta'} dato={'codigo'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={12} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography sx={{fontSize: 14, lineHeight: 1.1, fontWeight: 600}}>
                        Términos de Facturación y Cancelación de Contratos
                    </Typography>
                </Grid>

                {items.map((item, index) => (
                    <Grid container size={12} sx={{justifyContent: 'flex-start', px: 1, mt: -1}}>
                        <Typography sx={{fontSize: 12, lineHeight: 1.1}}>
                            <span style={{fontWeight: 600}}>{`${index + 1}) `}</span>
                            {item}
                        </Typography>
                    </Grid>
                ))}


            </Grid>

        </form>

    )

}
export default Formulario_Contrato

const items = [
    'Cada contrato de inversión comenzará a generar rendimientos 48 horas después de la fecha de la inversión.',
    'El contrato pagará un 1% diario (de lunes a domingo) sobre el capital invertido, hasta alcanzar el 200% del monto inicial.',
    'Sí el inversionista decide cancelar el contrato antes de su finalización, se aplicará una penalización del 40% del capital invertido.',
    'En caso de cancelación anticipada, se reembolsará únicamente el 60% del capital invertido.'
]